var flagIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"16\" viewBox=\"0 0 16 16\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#7F91A5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M8 1l6 3-6 3V1zM6 11.083c-2.892.245-5 1.011-5 1.917 0 1.104 3.134 2 7 2s7-.896 7-2c0-.906-2.108-1.671-5-1.917M8.002 12.5V7\"/>\n</svg>";

export { flagIcon as default };
